import "../styles/IconButton.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const IconButton = ({ icon, color = "#ff0000", onClick }) => {

    return (
        <button className="icon-button" onClick={onClick} style={{background: color}}><FontAwesomeIcon icon={icon}/></button>
    )
}

export default IconButton;
